module.exports = __webpack_public_path__ + "static/video-still.f501aef1.jpg";


//////////////////
// WEBPACK FOOTER
// /tmp/build_2cb81483/src/assets/images/home/video-still.jpg
// module id = 1322
// module chunks = 4